const responsive = `
@media only screen and (max-width: 960px) {
	.mainMenuContainer {
		margin: 0px;
		width: 100%;
		max-height: 60px;
	}
	.mainNav {
		display: inline-block;
	}
	nav.navbar-static-top.navbar.navbar-default .container {
		margin: 0px 0px;
		width: 100%;
		padding: 0px 8px;
    }
}
`;

export default responsive;
